import { createContext, useContext } from 'react';
import { NavItemKey } from './SecondaryNav';

type SecondaryNavItemContext = {
  /** The unique ID of the `SecondaryNav.Item` */
  itemId: NavItemKey;
  /** The unique ID of the `SecondaryNav.List` inside of a `SecondaryNav.Item`. */
  listId: string;
};

export const SecondaryNavItemContext = createContext<
  SecondaryNavItemContext | undefined
>(undefined);

/**
 * Context to share the unique IDs of the `SecondaryNav.Item` and `SecondaryNav.List`.
 */
export const useSecondaryNavItemContext = () => {
  return useContext(SecondaryNavItemContext);
};
